import { useMemo } from 'react';
import { PortfolioPropertyTag } from '@acp/shared';
import { useProperty } from './use-property';

function usePropertyCancelled(propertyId: string | number) {
    const { data: property, isLoading } = useProperty(propertyId);

    const isPropertyCancelled = useMemo(() => {
        if (property === undefined || isLoading) return false;

        return property.tags.includes(PortfolioPropertyTag.Cancelled);
    }, [property, isLoading]);

    return isPropertyCancelled;
}

export { usePropertyCancelled };
